import { Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

export class notificationData {
    message: string;
    action: string | null;
}

@Component({
    selector: "app-communication-message",
    templateUrl: "./communication-message.component.html",
    styleUrls: ["./communication-message.component.scss"]
})
export class CommunicationMessageComponent {
    msg: string;
    action: string | null;

    constructor(
        public sbRef: MatSnackBarRef<CommunicationMessageComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: notificationData
    ) {
        this.msg = data.message;
        this.action = data.action;
    }
}
